// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"3d3e163936d5b2fb2d83","966":"7cd23eba9be09ebe077c"}[chunkId] + ".js";
};